import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Box, Button, Typography } from '@mui/material';
import Breadcrumb from 'src/components/Breadcrumb';
import { useDispatch, useSelector } from 'react-redux';
import useDebounce from 'src/hooks/useDebounce';
import SearchBar from 'src/components/SearchBar';

import { selectInvestorQueryOptions } from 'src/store/selectors/investorSelector';
import FileDownloadIcon from '@mui/icons-material/GetApp';
import AddButton from 'src/components/AddButton/AddButton';
import {
  CLEAR_AGENTS,
  createAgentAction,
  downloadExcelAgents,
  loadAgentsList
} from 'src/store/actions/agentActions';
import useStyles from './styles';
import CreateAgentialog from './CreateAgentDialog';

const Toolbar = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const queryOptions = useSelector(selectInvestorQueryOptions);
  const [searchValue, setSearchValue] = useState('');
  const [open, setOpen] = useState(false);

  const debounceSearch = useDebounce(
    (name, queryOpts) => dispatch(loadAgentsList({ ...queryOpts, name })),
    400
  );

  const handleExcelExport = useCallback(() => {
    dispatch(downloadExcelAgents());
  }, [dispatch]);

  const handleSearch = useCallback(
    e => {
      const { value } = e.target;
      setSearchValue(value);
      debounceSearch(value, queryOptions);
    },
    [setSearchValue, debounceSearch, queryOptions]
  );

  const handleOpenCreateAgentForm = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const handleCloseCreateAgentForm = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const handleCreateAgent = useCallback(
    values => {
      dispatch(createAgentAction(values, handleCloseCreateAgentForm));
    },
    [dispatch, queryOptions, handleCloseCreateAgentForm]
  );

  useEffect(() => {
    dispatch(loadAgentsList());
    return () => dispatch({ type: CLEAR_AGENTS });
  }, []);

  return (
    <>
      <Box className={clsx(classes.root)}>
        <Breadcrumb />
        <Box
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Typography
            style={{ fontWeight: '400' }}
            color="primary"
            variant="h1"
          >
            {t('AGENTS.TITLE')}
          </Typography>
          <Box className={classes.actionsContainer}>
            <SearchBar
              handleSearch={handleSearch}
              searchValue={searchValue}
              placeholder={t('AGENTS.SEARCH_AGENTS')}
            />
            <Button
              className={clsx(classes.buttons, classes.outlined)}
              onClick={handleExcelExport}
              color="primary"
            >
              <FileDownloadIcon className={classes.icon} />
            </Button>
            <AddButton key="add-investor" onClick={handleOpenCreateAgentForm} />
          </Box>
          <CreateAgentialog
            open={open}
            handleClose={handleCloseCreateAgentForm}
            submit={handleCreateAgent}
          />
        </Box>
      </Box>
    </>
  );
};

export default Toolbar;
